import { useEffect, useState } from "react";

const useTool = () => {
  const [tools, setTools] = useState([]);
  useEffect(() => {
    fetch("https://electric-manfacturer-server.onrender.com/tool")
      .then((res) => res.json())
      .then((data) => setTools(data));
  }, []);

  return [tools, setTools];
};

export default useTool;
